// timer_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { start: String }

  connect() {
    console.log("Timer controller connected")
    console.log("Start value:", this.startValue)
    // Parse the end date
    this.endDate = new Date(this.startValue)

    // Start the countdown
    this.countdown()
  }

  countdown() {
    // Calculate the time remaining
    const now = new Date()
    const timeRemaining = Math.max(this.endDate.getTime() - now.getTime(), 0)

    if (timeRemaining === 0) {
      // L'offre est terminée
      this.element.innerHTML = '<p class="text-red-600 font-semibold">Cette offre est terminée</p>'
      return
    }

    // Calculate the number of days, hours, minutes, and seconds remaining
    const daysRemaining = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
    const hoursRemaining = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
    const secondsRemaining = Math.floor((timeRemaining % (1000 * 60)) / 1000)

    // Pad numbers with leading zeros
    this.daysTarget.textContent = String(daysRemaining).padStart(2, '0')
    this.hoursTarget.textContent = String(hoursRemaining).padStart(2, '0')
    this.minutesTarget.textContent = String(minutesRemaining).padStart(2, '0')
    this.secondsTarget.textContent = String(secondsRemaining).padStart(2, '0')

    // Schedule the next update
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.countdown()
      }, 1000)
    })
  }
}
